module.exports = __webpack_public_path__ + "static/media/class1.bafcf48e.jpg";